import React, { useState, useEffect } from "react";
import FullCalendar from "../Calendar/FullCalendar";
import Calendar from "../Calendar/calendar";
import AddTaskForm from "../Calendar/AddTaskForm";
export default function HeroEdit({ isEdit, setEdit, tasks, setTasks }) {
  return (
    <>
      <FullCalendar isEdit={isEdit} setEdit={setEdit} />
      <AddTaskForm
        isEdit={isEdit}
        setEdit={setEdit}
        setTasks={setTasks}
        tasks={tasks}
      />
    </>
  );
}
